'use client';

import { createContext } from 'react';

import type { BioContext } from '@ps/functions/bio/bioContext';

/** The contextual facts needed to open a post — no pre-fetched data. */
export interface OpenPostDetailInput {
  /** Store (creator) id the post belongs to. */
  storeId: string;
  postId: string;
  /** Creator url code — the author fallback for the fetched post. */
  urlCode: string;
  /**
   * The opening surface's bio context, or `null` on the non-1:1 DM inbox (mixed
   * creators, no single scope). Drives the post's permalink / share URL and the
   * unlock subscribe route; `null` → no bio URL, subscribe via the in-place modal.
   */
  bioContext: BioContext | null;
}

export interface PostDetailModalContextValue {
  openPostDetail: (input: OpenPostDetailInput) => void;
  closePostDetail: () => void;
}

export const PostDetailModalContext =
  createContext<PostDetailModalContextValue | null>(null);
